import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  UpdateQuotationClientRequest,
  UpdateQuotationClientResponse,
} from '../../../@types/UpdateQuotation'
import { api } from '../../../Services/API'
import { useUpdateQuotationStore } from '../../../Stores/useUpdateQuotationStore'
import { useWarningStore } from '../../../Stores/warningStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { WARNING_BAR } from '../../../constants/warningBar'
import { t } from '../../../i18n'
import { useErrorRequest } from '../../useErrorRequest'

const request = async (payload: UpdateQuotationClientRequest) => {
  const response = await api.post<UpdateQuotationClientResponse>(
    API_ROUTES.updateQuotation,
    payload,
  )

  return response.data
}

export const useUpdateQuotation = () => {
  const { handleErrorRequest } = useErrorRequest()
  const { setUpdateQuotation } = useUpdateQuotationStore()
  const { setWarningOptions } = useWarningStore()

  return useMutation({
    mutationFn: (payload: UpdateQuotationClientRequest) => request(payload!),
    onSuccess(data) {
      setUpdateQuotation(data)
      setWarningOptions({
        type: WARNING_BAR.type.success,
        labelTypes: [t('pages.step5.success')],
      })
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
